import { useHistory } from 'react-router-dom';

import { CallTaskCard } from './CallTaskCard';
import { useTaskStorage } from '../../hooks/useTaskStorage';
import { Button, GridList } from '../../../../components';
import { DateRangeInput } from '../../../../components/DateRangeInput';

const BatchCallListPage = () => {
  const history = useHistory();
  const { tasks, drafts, removeTask, removeDraft } = useTaskStorage();

  const allTasks = [...tasks, ...drafts];

  const handleDeleteClick = (taskId: string, isDraft: boolean) => {
    if (isDraft) {
      removeDraft(taskId);
    } else {
      removeTask(taskId);
    }
  };

  return (
    <>
      <div className="mt-xs">
        <h1 className="text-section font-semibold">Mass Outreach Tasks</h1>
      </div>
      <div className="flex flex-wrap justify-end items-center mb-4 gap-x-4 gap-y-2">
        <div className="text-medium text-semibold">
          <DateRangeInput />
        </div>

        <Button
          label="+ New Task"
          onClick={() => {
            history.push(`/batch_calls/task_wizard`);
          }}
          size="medium"
        />
      </div>

      <div className="flex flex-col items-center pt-[8rem] pb-lg">
        {!allTasks.length ? (
          <div className="sm:max-w-screen-sm md:max-w-screen-md xl:max-w-screen-xl xl:mx-auto md:mx-auto sm:mx-auto mx-sm w-full">
            <div className="flex flex-col justify-center items-center h-full text-3xl border border-border text-secondary bg-gray-100 rounded-lg p-10">
              No Data
            </div>
          </div>
        ) : (
          <div className="w-full max-w-screen-xl">
            <GridList
              items={allTasks}
              gap="gap-14"
              className="grid w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
              renderItem={(item, index) => (
                <CallTaskCard
                  key={index}
                  title={item?.taskName}
                  date={item?.createdAt}
                  createdBy={item?.createdBy}
                  contactsCount={item?.contactsCount}
                  status={item?.status}
                  taskId={item?.task_id}
                  onResultsClick={() =>
                    history.push(`/calls_management/${item?.task_id}`)
                  }
                  onCopyClick={() => {}}
                  onDeleteClick={() =>
                    handleDeleteClick(item?.task_id, item?.status === 'Draft')
                  }
                  isDraft={item?.status === 'Draft'}
                  onContinueClick={() => {
                    history.push(`/batch_calls/task_wizard/${item?.task_id}`);
                  }}
                />
              )}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default BatchCallListPage;
